import { render } from "./create-booking-shipment.vue?vue&type=template&id=021c606f&ts=true"
import script from "./create-booking-shipment.vue?vue&type=script&lang=ts"
export * from "./create-booking-shipment.vue?vue&type=script&lang=ts"

import "./create-booking-shipment.vue?vue&type=style&index=0&id=021c606f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__